import React from "react";
import { Box, useTheme } from "@mui/material";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { tokens } from "../theme";
import { dataGridStyles, localeText } from "../utils/dataGridConfig";
import ErrorComponent from "./ErrorComponent";
import { useGetDosagesQuery } from "../services/ticketService";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import LoadingComponent from "./LoadingComponent";
import { getProductUOMByName } from "../constants/enums";

const DosagesList = ({ ticketId, dosagesList, setDosagesList, isReadOnly = false }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  // If dosagesList is provided, use it; otherwise, fetch data using useGetDosagesQuery
  const { data: fetchedDosages, isLoading, error } = useGetDosagesQuery(ticketId, {
    skip: !!dosagesList || ticketId == null, // Skip the query if dosagesList is provided
  });

  // Use the provided dosagesList or fetchedDosages
  const dosages = dosagesList || fetchedDosages || [];

  if (error) {
    return <ErrorComponent />;
  }
  
  if (isLoading) {
    return <LoadingComponent />;
  }


  // Function to handle the deletion of a dosage
  const handleDeleteDosage = (id) => {
    if (dosagesList) {
      const updatedDosages = dosagesList.filter((dosage) => dosage.product_id !== id);
      setDosagesList(updatedDosages);
    }
  };

  // Define columns for the DataGrid
  const columns = [
    {
      field: "name",
      headerName: "Nombre",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "quantity",
      headerName: "Cantidad",
      type: "number",
      headerAlign: "left",
      align: "left",
      flex: 1,
    },
    {
      field: "product_UOM",
      headerName: "Unidad",
      type: "number",
      headerAlign: "left",
      align: "left",
      flex: 1,
      renderCell: (params) => {
        return getProductUOMByName(params.value).label;
      }
    },
  ];

  // Add the "Actions" column only if isReadOnly is false
  if (!isReadOnly) {
    columns.push({
      field: "actions",
      type: "actions",
      headerName: "Acciones",
      flex: 1,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<DeleteOutlinedIcon />}
          label="Delete"
          onClick={() => handleDeleteDosage(params.id)}
        />,
      ],
    });
  }

  return (
    <Box height="40vh" sx={dataGridStyles(colors)}>
      <DataGrid
        rows={dosages}
        columns={columns}
        loading={isLoading}
        getRowId={(row) => row.product_id}
        pageSizeOptions={[100]}
        loadingText="Cargando..."
        localeText={localeText}
        disableRowSelectionOnClick
        disableColumnMenu
        disableColumnSorting
      />
    </Box>
  );
};

export default DosagesList;